import { type ReactNode } from "react";

interface IHeaderProps {
  children: ReactNode;
  className?: string;
}

export default function Header({ children, className }: IHeaderProps) {
  return (
    <header className="fixed top-0 z-50 w-full bg-general-mint-700">
      <div className={`flex h-16 items-center px-4 ${className}`}>{children}</div>
    </header>
  );
}
